export const propL1Id = ({ l1Id }: { l1Id: number }) => l1Id;
